/* eslint camelcase: "off" */
/**
 * Investigations — auto-clustered patterns across events.
 *
 * Pending backend. No cluster-detection pipeline exists in django-monolith
 * yet — no Investigation model, no clustering job, no endpoint to list /
 * claim / close clusters. Implementing this needs:
 *   (1) an InvestigationCluster model with status + assignment,
 *   (2) detector jobs that scan VerificationDocument + EmployeeCredential
 *       for shared-ID / shared-BSUID / duplicate-checksum /
 *       long-expired-passport patterns,
 *   (3) admin endpoints to list and act on clusters.
 */
import React from 'react';

import { PendingBackendBanner } from './PendingBackend';


const InvestigationsTab: React.FC = () => (
  <div>
    <PendingBackendBanner>
      <strong>Entire tab pending backend.</strong> No cluster-detection pipeline exists in
      django-monolith yet — there&apos;s no Investigation model, no clustering job, and no
      endpoint to list/claim/close clusters. Implementing this needs: (1) an
      InvestigationCluster model with status + assignment, (2) detector jobs that scan
      VerificationDocument + EmployeeCredential for shared-ID / shared-BSUID /
      duplicate-checksum / long-expired-passport patterns, (3) admin endpoints to list
      and act on clusters.
    </PendingBackendBanner>
  </div>
);

export default InvestigationsTab;
